import React from "react";
import {
  Box, Card, CardContent, Container, Typography, Button, Stack,
} from "@mui/material";
import { Icon } from "@iconify/react";
import Page from "../components/Page";

export default function DMCenter() {
  return (
    <Page title="DM Center | Fire Investing Admin">
      <Container maxWidth="md">
        <Box sx={{ pb: 3 }}>
          <Typography variant="h4" sx={{ fontWeight: 700 }}>DM Center</Typography>
          <Typography variant="body2" color="text.secondary">
            Direct messages between users and Fire Investing support
          </Typography>
        </Box>
        <Card sx={{ borderRadius: 3, boxShadow: "0 4px 20px rgba(0,0,0,0.25)" }}>
          <CardContent sx={{ p: 6, textAlign: "center" }}>
            <Box sx={{ mb: 3 }}>
              <Icon icon="eva:message-square-fill" width={80} height={80} color="#FF6C40" />
            </Box>
            <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
              DM Integration Coming Soon
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 3, maxWidth: 500, mx: "auto" }}>
              This panel is ready for integration with the Fire Investing app DM system.
              Once the in-app DM feature is activated, admin support conversations will
              appear here in real time.
            </Typography>
            <Stack direction="row" spacing={2} justifyContent="center">
              <Button variant="outlined" startIcon={<Icon icon="eva:code-fill" />} disabled>
                Awaiting App Integration
              </Button>
              <Button variant="contained" sx={{ bgcolor: "#FF6C40" }} startIcon={<Icon icon="eva:bell-fill" />}
                onClick={() => alert("When the DM feature is live in the app, this panel will auto-populate from Firestore 'SupportDMs' collection.")}>
                Integration Guide
              </Button>
            </Stack>
            <Box sx={{ mt: 4, p: 3, bgcolor: "background.default", borderRadius: 2, textAlign: "left" }}>
              <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1 }}>Integration Notes for Dev Team:</Typography>
              <Typography variant="body2" color="text.secondary" component="div">
                <ul style={{ margin: 0, paddingLeft: 20 }}>
                  <li>Create Firestore collection: <code>SupportDMs</code></li>
                  <li>Each doc: {"{ userId, messages: [{ sender, text, timestamp }], status: 'open'|'resolved' }"}</li>
                  <li>Add DM button in app → creates doc in SupportDMs</li>
                  <li>Admin panel will listen via onSnapshot for real-time updates</li>
                  <li>Admin replies write back to the same doc's messages array</li>
                </ul>
              </Typography>
            </Box>
          </CardContent>
        </Card>
      </Container>
    </Page>
  );
}
